import { render, staticRenderFns } from "./FleetRepos.vue?vue&type=template&id=067d75ca&scoped=true&"
import script from "./FleetRepos.vue?vue&type=script&lang=js&"
export * from "./FleetRepos.vue?vue&type=script&lang=js&"
import style0 from "./FleetRepos.vue?vue&type=style&index=0&id=067d75ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067d75ca",
  null
  
)

export default component.exports